'use client';

import { deletePharmacy } from 'actions/Database';
import { DBPharmacy } from 'db/schema/pharmacies';
import { useAppDispatch } from 'lib/hooks';
import { removePharmacy } from 'slices/pharmacySlice';
import styles from 'styles/sunfire.forms.module.css';
import { formatAddress } from 'utils/formatters';
import WarningCircleIcon from 'components/icons/WarningCircleIcon';
import DeleteIcon from 'components/icons/DeleteIcon';

interface PharmacySavedListProps {
  pharmacies: DBPharmacy[];
}

const PharmacySavedList = ({ pharmacies }: PharmacySavedListProps) => {
  const dispatch = useAppDispatch();

  const handleRemovePharmacy = async (pharmacy: DBPharmacy) => {
    const removed = await deletePharmacy(pharmacy);
    dispatch(removePharmacy({ ...removed, created_at: null }));
  };

  return (
    <div className={styles.listContainer}>
      <h3>Your Saved Pharmacies ({pharmacies.length})</h3>

      {pharmacies.length === 0 ? (
        <div className={styles.emptyList}>
          <WarningCircleIcon size="small" />
          <span>You haven&apos;t saved any pharmacies.</span>
        </div>
      ) : (
        <ul className={`${styles.savedList} ${styles.pharmacyList}`}>
          {pharmacies.map((pharmacy) => {
            return (
              <li key={pharmacy.id} className="spaceBetween">
                <div>
                  <h3>{pharmacy.name}</h3>
                  <p>
                    <b>{formatAddress(pharmacy)}</b>
                  </p>
                </div>
                <div className={styles.listButton}>
                  <button
                    className="button"
                    onClick={() => handleRemovePharmacy(pharmacy)}
                  >
                    <DeleteIcon />
                    Delete
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default PharmacySavedList;
